import Header from 'shared/components/Header'
import Text from 'shared/components/Text'

import HeaderEditor from 'shared/components/Header/editor'
import TextEditor from 'shared/components/Text/editor'

import HeaderPreview from 'shared/components/Header/preview'
import TextPreview from 'shared/components/Text/preview'

export const COMPONENTS_MAP = {
  'header': Header,
  'text': Text
}

export const COMPONENTS_EDITOR_MAP = {
  'header': HeaderEditor,
  'text': TextEditor
}

export const COMPONENTS_PREVIEW_MAP = {
  'header': HeaderPreview(),
  'text': TextPreview()
}

export const DEVICE_VIEWPORT_RESOLUTIONS = {
  desktop: {
    width: 1440,
    height: 'auto'
  },
  tablet: {
    width: 768,
    height: 'auto'
  },
  mobile: {
    width: 375,
    height: 'auto'
  }
}

export const THEME_ELEVATION = {
  1: { label: 'None' },
  2: { label: 'Small' },
  3: { label: 'Medium' },
  4: { label: 'Large' },
  5: { label: 'Huge' }
}

export const THEME_ROUNDNESS = {
  1: { label: 'None' },
  2: { label: 'Small' },
  3: { label: 'Medium' },
  4: { label: 'Large' },
  5: { label: 'Huge' }
}

export const THEME_SPACING = {
  1: { label: 'Compact' },
  2: { label: 'Comfortable' },
  3: { label: 'Spacious' },
}

export const FONT_VARIANT_MAP = {
  'regular': 'Regular',
  'italic': 'Italic',
  '100': 'Thin',
  '200': 'Extra Light',
  '300': 'Light',
  '400': 'Normal',
  '500': 'Medium',
  '600': 'Semi Bold',
  '700': 'Bold',
  '800': 'Extra Bold',
  '900': 'Black',
  '100italic': 'Thin Italic',
  '200italic': 'Extra Light Italic',
  '300italic': 'Light Italic',
  '400italic': 'Normal Italic',
  '500italic': 'Medium Italic',
  '600italic': 'Semi Bold Italic',
  '700italic': 'Bold Italic',
  '800italic': 'Extra Bold Italic',
  '900italic': 'Black Italic'
}


// WEBPACK FOOTER //
// ./src/shared/enums/index.js